export interface ErrorResponse {
  success: false;
  error: string;
  status?: number;
  code?: string;
  data?: any;
}

export interface SuccessResponse<T> {
  success: true;
  data: T;
}

export type Response<T> = SuccessResponse<T> | ErrorResponse;

export const errorResponse = (
  errorOrParams: string | { error: string; status?: number; code?: string; data?: any },
  options?: {
    status?: number;
    code?: string;
    data?: any;
  },
): ErrorResponse => {
  if (typeof errorOrParams === "string") {
    return {
      success: false,
      error: errorOrParams,
      status: options?.status,
      code: options?.code,
      data: options?.data,
    };
  }
  return {
    success: false,
    error: errorOrParams.error,
    status: errorOrParams.status,
    code: errorOrParams.code,
    data: errorOrParams.data,
  };
};

export const successResponse = <T>(data: T): SuccessResponse<T> => ({
  success: true,
  data,
});

export const isSuccessResponse = <T>(response: Response<T>): response is SuccessResponse<T> => {
  return (response as any).success === true && 'data' in (response as any);
};
